import React from 'react';
import { beforeItems, afterItems } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-81" data-mp="2bk4kmbqv9is9">
      <div className="mx-auto max-w-5xl" data-id="element-82" data-mp="26ne981q0bbd6">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-83" data-mp="26k9ysmly7je2">
          From opening multiple documents before every consultation…{' '}
          <em className="italic text-teal-600" data-id="element-84" data-mp="2za8psnjpdqld">to a professional with a clear visual system</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-navy-700/80 sm:text-lg" data-id="element-85" data-mp="2u9ufeyumq4k6">
          The problem isn't necessarily a lack of information. The problem is having too much
          information scattered across different sources when you need to organize a consultation.
        </p>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-86" data-mp="19w3mddisbmp8">
          <div className="flex flex-col rounded-3xl border-2 border-red-200 bg-white p-5 sm:p-7" data-id="element-87" data-mp="19uiszr87i9sy">
            <p className="inline-flex w-fit items-center gap-2 rounded-full bg-red-100 px-3.5 py-1.5 text-[12px] font-extrabold uppercase tracking-wide text-red-700" data-id="element-88" data-mp="175vtqpsyjjiu">
              ❌ Before
            </p>
            <ul className="mt-5 flex flex-1 flex-col gap-4" data-id="element-89" data-mp="y4ehxjml23zy">
              {beforeItems.map(item => <li key={item.text} className="flex gap-3" data-id="element-90" data-mp="135vgv9libgdw">
                  <span aria-hidden="true" className="text-lg leading-none" data-id="element-91" data-mp="odtlo2udtbk7">
                    {item.icon}
                  </span>
                  <span className="text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-92" data-mp="t6w8zt8kfory">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl border-2 border-grass-500/40 bg-white p-5 sm:p-7" data-id="element-93" data-mp="5g0ir0jrd1mt">
            <p className="inline-flex w-fit items-center gap-2 rounded-full bg-grass-500/12 px-3.5 py-1.5 text-[12px] font-extrabold uppercase tracking-wide text-grass-600" data-id="element-94" data-mp="af3mmho051t7">
              ✅ With GLP-1 Decision Map™
            </p>
            <ul className="mt-5 flex flex-1 flex-col gap-4" data-id="element-95" data-mp="27dasxk7djxel">
              {afterItems.map(item => <li key={item.text} className="flex gap-3" data-id="element-96" data-mp="23d0j1wggomug">
                  <span aria-hidden="true" className="text-lg leading-none" data-id="element-97" data-mp="1ycurega6z0cd">
                    {item.icon}
                  </span>
                  <span className="text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-98" data-mp="2v23ovgnzy597">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="I want to organize my consultations" data-id="element-99" data-mp="2m0m3birtlbd4" />
      </div>
    </section>;
}